import React from 'react';
import { ShieldAlert } from 'lucide-react';
import { C } from '../shared';
import { ModuleBlock } from '../ModuleBlock';

export const ACKS = [
  { key: 'duty_to_take_reasonable_care', label: 'The client has read the s20B warning above and understands their duty to take reasonable care not to make a misrepresentation.' },
  { key: 'documents_received', label: 'The client has received the PDS, TMD, Key Facts Sheet and FSG, and consents to the privacy terms.' },
];

export const DisclosureStep = ({ modules, answers, confirmed, setAnswer, confirm, change, acks, setAcks }) => (
  <div data-testid="rj-disclosure-step">
    <div className="rounded-sm border p-3" style={{ borderColor: 'rgba(178,117,22,0.5)', background: 'rgba(178,117,22,0.05)' }} data-testid="rj-s20b-warning">
      <p className="text-xs font-semibold flex items-center gap-1.5" style={{ color: C.amber }}><ShieldAlert className="w-4 h-4" /> Your duty to take reasonable care not to make a misrepresentation (Insurance Contracts Act 1984, s20B)</p>
      <p className="text-[11px] mt-1 leading-relaxed" style={{ color: C.navy }}>
        This is a consumer insurance contract. Before it is entered into, the person to be insured has a duty to take reasonable care not to make a misrepresentation to the insurer.
        Every answer must be honest and accurate to the best of their knowledge. If a question is not understood, or an answer is not known, they should say so rather than guess.
        A misrepresentation can allow the insurer to reduce or refuse a claim, or cancel the policy. The answers prefilled from public registers are shown for confirmation — they must be corrected where they are wrong.
      </p>
    </div>
    {modules.map(m => <ModuleBlock key={m.name} m={m} answers={answers} confirmed={confirmed} setAnswer={setAnswer} confirm={confirm} change={change} />)}
    <div className="mt-3 space-y-2" data-testid="rj-acknowledgements">
      {ACKS.map(a => (
        <label key={a.key} className="flex items-start gap-2 text-[11px] cursor-pointer" style={{ color: C.navy }}>
          <input type="checkbox" checked={!!acks[a.key]} onChange={e => setAcks({ ...acks, [a.key]: e.target.checked })} className="mt-0.5" data-testid={`rj-ack-${a.key}`} />
          <span>{a.label}</span>
        </label>
      ))}
      <p className="text-[9px]" style={{ color: C.slate }}>Acknowledgements are consents, not risk information — they are recorded on the bind and not counted as typed inputs.</p>
    </div>
  </div>
);
